export default "__VITE_ASSET__0ymT9dKw__"